<script setup lang="ts">
import { PersonalBaziIndicators } from "@/types/calculators";
import { defineProps } from "vue";
import { useI18n } from "vue-i18n";

defineProps<{
  personalIndicators: PersonalBaziIndicators;
}>();

const { t } = useI18n();
</script>

<template>
  <div>
    <table
      class="text-base md:text-lg text-brown text-left font-semibold border-separate border-spacing-x-4"
    >
      <tbody>
        <tr>
          <td>
            {{
              t("calculators.bazi.results.personal-indicators.personal-element")
            }}
          </td>
          <td>{{ personalIndicators.personal_element }}</td>
        </tr>
        <tr>
          <td>
            {{ t("calculators.bazi.results.personal-indicators.gua-number") }}
          </td>
          <td>{{ personalIndicators.gua_number }}</td>
        </tr>
        <tr>
          <td>
            {{ t("calculators.bazi.results.personal-indicators.nobleman") }}
          </td>
          <td>{{ personalIndicators.nobleman }}</td>
        </tr>
        <tr>
          <td>{{ t("calculators.bazi.results.personal-indicators.void") }}</td>
          <td>{{ personalIndicators.void }}</td>
        </tr>
        <tr>
          <td>{{ t("calculators.bazi.results.personal-indicators.peach") }}</td>
          <td>{{ personalIndicators.peach }}</td>
        </tr>
        <tr>
          <td>{{ t("calculators.bazi.results.personal-indicators.horse") }}</td>
          <td>{{ personalIndicators.horse }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
